export const PROFILE_BASE_PATH = "/profile";

export const PROFILE_CHILD_PATHS = {
  HOME: "",
  LANGUAGE: "language",
  SUBSCRIPTION: "my-subscription",
  BILLING_HISTORY: "billing-history",
  MANAGE_MEMBERSHIP: "manage-membership",
  CHANGE_MEMBERSHIP: "change-membership/:planId",
  HELP_CENTRE: "help-centre-faq",
} as const;
